export default __webpack_public_path__ + "static/media/motherbabybanner.5e27e3d9.svg";